import ErrorCard from "Components/errorCards/ErrorCard/ErrorCard";
import ErrorCardButton from "Components/errorCards/ErrorCard/ErrorCardButton/ErrorCardButton";
import ErrorCardFinePrint from "Components/errorCards/ErrorCard/ErrorCardFinePrint/ErrorCardFinePrint";
import { ButtonStyle } from "lexus-style-guide/buttons/shared";
import { FC } from "react";

interface Prop {
    onYes: () => void;
}

const ReloadConfirmationCard: FC<Prop> = ({ onYes }) => {
    return (
        <ErrorCard title={"refresh the encore app"} className={"is-bg-type-light"}>
            <ErrorCardFinePrint>
                The content in this app is out of date and you may be missing out on the latest offers and benefits.
            </ErrorCardFinePrint>
            <ErrorCardButton onClick={onYes} buttonStyle={ButtonStyle.Primary}>
                Reload the app
            </ErrorCardButton>
        </ErrorCard>
    );
};

export default ReloadConfirmationCard;
